import ES from './es';
import EN from './en';

const login = {
    ES,
    EN
};

export default login;
